<div class="pdf-shell">
  <div
    class="pdf-toolbar-hotspot"
    *ngIf="pdf && showFooter"
    [class.is-collapsed]="toolbarHidden"
    (mouseenter)="revealToolbar()"
    (mouseleave)="scheduleHideToolbar()"
    (focusin)="revealToolbar()"
    (focusout)="onToolbarFocusOut($event)">
    <footer
      class="pdf-toolbar"
      [class.pdf-toolbar--hidden]="toolbarHidden"
      [ngClass]="{'download-footer': canDownload, 'pagination-footer': pdf._pdfInfo.numPages > 1}">

      <div class="zoom-button-container">
        <button (click)="applyZoom('less')">
          <mmp5-mm-icons class="z-button" [icon]="['icon', 'icon-zoom-out-foto']"></mmp5-mm-icons>
        </button>
        <mmp5-fieldset-haruki
        [formControl]="zoomField"
        [type]="'number'"
        [small]="true"
        [label]="''"
        [key]="'zoomField'">
        </mmp5-fieldset-haruki>
        <button (click)="applyZoom('more')">
          <mmp5-mm-icons class="z-button" [icon]="['icon', 'icon-zoom-in-foto']"></mmp5-mm-icons>
        </button>

        <div *ngIf="search">
          <mmp5-fieldset-haruki
          class="search"
          [formControl]="search"
          [label]="'view.search.search' | translate"
          [type]="'search'">
          </mmp5-fieldset-haruki>
        </div>
      </div>


      <div class="pagination-buttons" *ngIf="pdf._pdfInfo.numPages > 1">
        <button class="btn btn-primary" [disabled]="currentPage === 1" (click)="navigateTo(-1)">
          <mmp5-mm-icons [icon]="['fa-solid', 'fa-chevron-left']"></mmp5-mm-icons>
        </button>
        <span>
          {{ currentPage }}/{{ pdf._pdfInfo.numPages }}
        </span>
        <button class="btn btn-primary" [disabled]="currentPage === pdf._pdfInfo.numPages" (click)="navigateTo(1)">
          <mmp5-mm-icons [icon]="['fa-solid', 'fa-chevron-right']"></mmp5-mm-icons>
        </button>
      </div>

      <div class="download-button">
        <button *ngIf="isPrinting && canDownload" class="btn btn-secondary" (click)="print()">
          <mmp5-mm-icons [icon]="['fa-solid', 'fa-download']"></mmp5-mm-icons>
        </button>
      </div>
    </footer>
  </div>

  <pdf-viewer
  *ngIf="url && url != 'error'"
  [src]="url"
  #PdfViewerComponent
      [(page)]="currentPage"
      (pageChange)="onPageChange($event)"
      [render-text]="true"
      [render-text-mode]="blockCopy"
      [show-all]="true"
      [original-size]="false"
      [zoom]="zoomField.value"
      [zoom-scale]="'page-fit'"
      style="width: 100%; height: 88vh; display: block;"
      (after-load-complete)="callBackFn($event)"
  ></pdf-viewer>

  <div class="alert alert-danger" *ngIf="url == 'error'">
      Erro ao carregar a mídia
  </div>
</div>
